module.exports = __webpack_public_path__ + "img/logo.47b8b195.png";